import React, { Component } from "react";
import { bool, string, shape } from "prop-types";

import { Link } from "react-router-dom";

import * as i18nUtils from "util/i18n";
import { getMultipleTransfersI18nKey } from "util/multiple-transfers";

import FormattedDate from "pages/_components/FormattedDate";

import { resizableRoute } from "pages/_components/Resizable";
import InfoTag from "pages/_components/InfoTag";
import { findScheduleDesc } from "util/scheduler";
import { getTransferActivityName } from "util/transferInternalTitleLabels";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

class ScheduledTransactionsListItem extends Component {
    static propTypes = {
        activityName: string.isRequired,
        idActivity: string.isRequired,
        idTransaction: string.isRequired,
        isDesktop: bool,
        isEditable: bool.isRequired,
        creationDateTime: string.isRequired,
        idTransactionStatus: string.isRequired,
        data: shape().isRequired,
    };

    static defaultProps = {
        isDesktop: true,
    };

    renderRightContent = (data) => {
        const currency = data?.amount?.currency ? i18nUtils.get(`currency.label.${data.amount.currency}`) : "";
        const amount = data?.amount?.quantity ? data.amount.quantity : data?.amount;
        return (
            <div className="card__component-item-currency d-flex align-items-center">
                <span className="pr-1">{currency}</span>
                <span>
                    {amount &&
                        amount?.toLocaleString("es-ES", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                </span>
            </div>
        );
    };

    render() {
        const {
            activityName,
            idActivity,
            idTransaction,
            idTransactionStatus,
            isDesktop,
            creationDateTime,
            data,
            isEditable,
        } = this.props;

        const displayActivityName =
            idActivity === "transfer.multiple.send"
                ? i18nUtils.get(getMultipleTransfersI18nKey("activities.transfer.multiple.send"))
                : getTransferActivityName(idActivity, activityName);

        return (
            <CardContainer
                renderAs={Link}
                to={!isEditable ? `/transaction/${idTransaction}` : "/desktop"}
                className="widget__card-transactions">
                <Card
                    icon={`images/transfer-${idTransactionStatus}.svg`}
                    iconClass="card__pending-transaction-icon"
                    rightArrow
                    title={
                        <div className="card__pending-transaction-data-title">
                            <div className="d-flex align-items-center">
                                <span className="card__pending-transaction-data-creation">
                                    {i18nUtils.get("transactions.list.item.created")}
                                </span>
                                <FormattedDate showTime date={creationDateTime} />
                                {isDesktop && (
                                    <InfoTag
                                        tagBackground="#757575"
                                        message={findScheduleDesc(data?.scheduler?.selectedOption)}
                                    />
                                )}
                            </div>
                        </div>
                    }
                    bottom={
                        <div className="card__pending-transaction-data-bottom">
                            <span>{displayActivityName}</span>
                            {!isDesktop && (
                                <InfoTag
                                    tagBackground="#757575"
                                    message={findScheduleDesc(data?.scheduler?.selectedOption)}
                                />
                            )}
                        </div>
                    }
                    rightContent={this.renderRightContent(data)}
                />
            </CardContainer>
        );
    }
}

export default resizableRoute(ScheduledTransactionsListItem);
